<div
  class="search-toolbar"
  *ngIf="(isSmallScreen$ | async) !== true; else smallScreen"
>
  <div class="back-btn-wrapper">
    <app-back-button (goBack)="onGoBackToCatalog()"></app-back-button>
  </div>
  <div class="sport-selector">
    <app-sport-selector
      [sports]="sports$ | async"
      [selectedSport]="selectedSport$ | async"
      (changeSport)="onChangeSport($event)"
    ></app-sport-selector>
  </div>
  <div class="search-bar">
    <app-search-bar
      *ngIf="searchDisplay !== 'map'; else searchPlaceBar"
      [typedTerm]="typedTerm$ | async"
      (typedTermChange)="onChangeTypedTerm($event)"
      (searchTerm)="onSearchTerm($event)"
    ></app-search-bar>
  </div>
  <div class="display-btns-wrapper">
    <button
      class="display-btn"
      (click)="onChangeSearchDisplay('list')"
      [ngClass]="{ active: searchDisplay === 'list' }"
    >
      <span class="icon icon-all-liste"></span>
      <span class="display-btn-label">{{
        "browse.search.toolbar.listDisplay" | translate
      }}</span>
    </button>
    <button
      class="display-btn"
      (click)="onChangeSearchDisplay('map')"
      [ngClass]="{ active: searchDisplay === 'map' }"
    >
      <span class="icon icon-carte"></span>
      <span class="display-btn-label">{{
        "browse.search.toolbar.mapDisplay" | translate
      }}</span>
    </button>
  </div>
</div>

<ng-template #smallScreen>
  <div class="search-toolbar">
    <div class="back-and-search">
      <div class="back-btn-wrapper">
        <app-back-button (goBack)="onGoBackToCatalog()"></app-back-button>
      </div>
      <div class="search-bar">
        <app-search-bar
          *ngIf="searchDisplay !== 'map'; else searchPlaceBar"
          [typedTerm]="typedTerm$ | async"
          (typedTermChange)="onChangeTypedTerm($event)"
          (searchTerm)="onSearchTerm($event)"
        ></app-search-bar>
      </div>
    </div>
    <div class="sport-and-display">
      <div class="sport-selector">
        <app-sport-selector
          [sports]="sports$ | async"
          [selectedSport]="selectedSport$ | async"
          (changeSport)="onChangeSport($event)"
        ></app-sport-selector>
      </div>
      <div class="display-btns-wrapper">
        <button
          class="display-btn active"
          (click)="onChangeSearchDisplay('list')"
          [ngClass]="{ active: searchDisplay === 'list' }"
        >
          <span class="icon icon-all-liste"></span>
        </button>
        <button
          class="display-btn"
          (click)="onChangeSearchDisplay('map')"
          [ngClass]="{ active: searchDisplay === 'map' }"
        >
          <span class="icon icon-carte"></span>
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #searchPlaceBar>
  <app-search-place-bar></app-search-place-bar>
</ng-template>
